import { createContext } from "react";

const ContextTodoList = createContext();

export default ContextTodoList;
